module.exports = __webpack_public_path__ + "img/img27.1999e918.svg";